import { ActionType, NetworkActionPrefix } from '../utils/constants';
import defaults from '../api/defaults';
import {
    combineReducers, networkEntityAddReducer, networkEntityDeleteReducer, networkEntityEditReducer, networkEntityLoadReducer, networkObjectLoadReducer, pipeReducers
} from '../utils/reducerFactory';
import { deepAssign } from '../utils';

function index(state, id) {
    return id ? (id = state.getIndexByID(id)) !== -1 ? id : state.length : undefined;
}

const keyVariables = {
    companyAccessFunctionalityAddOnIndex: (state, action) => index(state, action.companyAccessFunctionalityAddOnID)
};

export default combineReducers({
    clientCompany: networkEntityAddReducer(NetworkActionPrefix.ADD_CLIENT_COMPANY_PREFIX, defaults.Company, (state, action) => action.clientCompany),
    company: pipeReducers(
        networkEntityLoadReducer(NetworkActionPrefix.LOAD_CURRENT_COMPANY_PREFIX, defaults.Company),
        networkEntityEditReducer(NetworkActionPrefix.EDIT_CURRENT_COMPANY_PREFIX, null, (state, action) => action.currentCompany)
    ),
    companyAccessFunctionalityAddOns: pipeReducers(
        networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_COMPANY_ACCESS_FUNCTIONALITY_ADD_ONS_PREFIX, defaults.NetworkArray),
        combineReducers({
            Data: combineReducers({
                '@companyAccessFunctionalityAddOnIndex': pipeReducers(
                    networkEntityAddReducer(NetworkActionPrefix.ADD_COMPANY_ACCESS_FUNCTIONALITY_ADD_ON_PREFIX, null, (state, action) => action.companyAccessFunctionalityAddOn),
                    networkEntityDeleteReducer(NetworkActionPrefix.DELETE_COMPANY_ACCESS_FUNCTIONALITY_ADD_ON_PREFIX)
                )
            }, keyVariables)
        })
    ),
    companyTemplateTypes: networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_COMPANY_TEMPLATE_TYPES_PREFIX, defaults.NetworkArray),
    partnerCompanies: pipeReducers(
        networkObjectLoadReducer(NetworkActionPrefix.LOAD_PARTNER_COMPANIES_PREFIX, defaults.NetworkArray),
        (state, action) => {
            if (action.type === ActionType.SIGN_PARTNER_AGREEMENT_SUCCESS) {
                return deepAssign(state, {
                    Data: {
                        [state.Data.getIndexByID(action.companyID)]: {
                            PartnerAgreementSignedDate: new Date(),
                            PartnerAgreementSignedByUser: action.userName
                        }
                    }
                });
            }

            return state;
        }
    ),
    userPartnerAccesses: pipeReducers(
        networkObjectLoadReducer(NetworkActionPrefix.LOAD_USER_PARTNER_ACCESSES_PREFIX, defaults.NetworkArray),
        (state, action) => {
            if (action.type === ActionType.SET_PARTNER_CLIENT_COMPANY_ACCESSES_FOR_USER_SUCCESS) {
                return deepAssign(state, {
                    Data: state.Data.map((data) => {
                        if (data.UserID === action.userID) {
                            return { AccessibleCompanies: action.companyIDs };
                        }

                        return {};
                    })
                });
            }

            return state;
        }
    )
});
